import { Observable, BehaviorSubject } from 'rxjs';
import { AppState } from '../../../models/app-state';
import { StorageService } from '../storage/storage.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class AppStateService extends BehaviorSubject<AppState> {
	private readonly APP_STATE_KEY: string = 'APP_STATE_KEY';
	constructor(private storageService: StorageService) {
		super(null);

		this.getAppState().then((state) => {
			this.next(state);
		});
	}

	async getAppState(): Promise<AppState> {
		let appState = await this.storageService.getItem<AppState>(this.APP_STATE_KEY);
		if (!appState) {
			appState = {
				isOfflineMode: false
			};
		}

		return appState;
	}

	async setAppState(appState: AppState) {
		this.next(appState);
		return this.storageService.setItem(this.APP_STATE_KEY, appState);
	}

	async isOfflineMode() {
		const appState = await this.getAppState();
		return appState.isOfflineMode;
	}

	async setOfflineMode(enabled: boolean) {
		const appState = await this.getAppState();
		appState.isOfflineMode = enabled;
		this.setAppState(appState);
	}
}
